<template>
    <header class="align-center flex justify-between">
        <h1 class="text-heading-md font-bold text-content-primary">Create file</h1>
        <DsButton
            v-if="viewOrderUrl"
            :href="viewOrderUrl"
            size="sm"
            variant="tertiary"
        >
            View this file in Closinglock
        </DsButton>
    </header>
</template>

<script setup lang="ts">
import DsButton from '@/components/design-system/form/input/DsButton.vue';

defineProps<{
    viewOrderUrl?: string;
}>();
</script>
